import { CreateSiteOptions } from '../../interfaces/api/Site';
import { arrayToQueryString, toQueryParamsString } from '../../utils/ApiUtils';

import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getAll: (name, page = 1, limit = 10): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites${toQueryParamsString({ name, page, limit })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  create: (customerId: string, site: CreateSiteOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/customers/${customerId}/sites`,
    method: 'POST',
    body: JSON.stringify(site),
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  }),
  update: (id: string, site: CreateSiteOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites/${id}`,
    method: 'PUT',
    body: JSON.stringify(site),
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  }),
  removeLogo: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites/${id}/logos`,
    method: 'DELETE',
    credentials: 'include',
  }),
  addLogo: (id: string, file: File): ApiReturnType => {
    const params = new FormData();
    params.append('file', file);

    return {
      endpoint: `${API_BASE_URL}/v2/crm/sites/${id}/logos`,
      method: 'POST',
      body: params,
      credentials: 'include',
    };
  },
  addContact: (siteId: string, contactId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/contacts/${contactId}/sites/${siteId}`,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    method: 'PATCH',
  }),
  getSiteOfLegacyCustomer: (customerId: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/crm/legacy/customers/${customerId}/site`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  get: (siteId: string) => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites/${siteId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getBatch: (siteIds: string[]) => ({
    endpoint: `${API_BASE_URL}/v2/crm/sites/batch${arrayToQueryString('ids', siteIds)}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  revokeAccess: (siteId: string, customerAccessId: string) => ({
    endpoint: `${API_BASE_URL}/v2/customer-access/customer-accesses/revoke`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ siteId, customerAccessId }),
    method: 'POST',
  }),
};
